import { Alert, Button, Container, CssBaseline, Paper, TextField, Typography } from '@mui/material';
import React from 'react'
import { Link } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { db } from '../../firebase';
import emailjs from '@emailjs/browser';
import BarLogin from '../Screen/BarLogin';

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: '1rem',
    textAlign: 'center'
  },
  submit: {
    margin: '3rem',
    padding: '1.5rem',
  },
  headerText: {
      margin: '3rem'
  }
}));
function Forgot() {
      const classes = useStyles();
    const [email, setEmail] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [msg, setMsg] = React.useState(null);

    const generatePassword = (len) => {
    let result = [];
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@-%$#!&+?';
    const charLength = characters.length;
    for (let i = 0; i < len; i++) {
        result.push(characters.charAt(Math.floor(Math.random() * charLength)));
    }
    return result.join('');
}
    const handleOnSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        if (!email) {
            setLoading(false);
            return setError('Email required');
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            setLoading(false);
            return setError('Email address is invalid');
        } 
         db.collection("users")
        .where("email", "==", email.toLowerCase()).get()
        .then(function(querySnapshot) {
            if (!querySnapshot.empty) {
                       var templateParams = {
                    email: email.trim(),
                    subject: 'Reset Password',
                    message: 'https://geneva.netlify.app/reset/'+email.toLowerCase(),
                    comp_name: 'Dev Arena'
                   
                 };
         emailjs.send("service_oiqb0bo","template_ntw8bxg",templateParams,"wwlXdyG0epB_-bxgu")
            .then(function(response) {
               setMsg('Check your mail for reset link')
              setLoading(false);
            }, function(error) {
              console.log(error)
            }); 
            }
            else {
              setError("Email does not exist")
              setLoading(false);
            }
        });
    }
  return (
    <div>
    <BarLogin/>
          <Container component="main" maxWidth="xs" className="card" style={{padding:'3rem'}}>
              <CssBaseline/>
               {msg ? (
                    <Alert onClose={() => {setMsg('')}} severity="success">
                       {msg} 
                    </Alert>
                ) : null}
              <Paper className={classes.paper} style={{padding:'2rem'}}>
                  <Typography
                      component="h1"
                      variant="h4"
                      className={classes.headerText}
                  >
                      Forgot your password?
                  </Typography>
                  <Typography component="h1" variant="body2">
                    Please enter the email address associated with your account and We will email you a link to reset your password.
                  </Typography>
                  <form className={classes.form} noValidate>
                    {error ? (
                        <Alert onClose={() => setError(null)} severity="error">
                            {error}
                        </Alert>
                    ) : null}
                      <TextField
                          variant="outlined"
                          margin="normal"
                          required
                          fullWidth
                          id="email"
                          label="Email Address"
                          name="email"
                          autoComplete="email"
                          autoFocus
                          value={email}
                          onChange={e => setEmail(e.target.value)}
                      />
                      <Button
                          type="submit"
                          fullWidth
                          variant="contained"
                          color="primary"
                          size="large"
                          className={classes.submit}
                          disabled={loading || !email}
                          onClick={handleOnSubmit}
                      >
                          Reset Password
                      </Button>
                      <Link to="/login" variant="body1">
                          Remember Password?
                      </Link>
                  </form>
              </Paper>
          </Container>
    </div>
  )
}

export default Forgot